<template>
  <!-- 外层页面左右铺满，无横向空白 -->
  <div class="full-width-wrap">
    <el-card class="full-card">
      <el-form
        ref="form"
        :model="formData"
        label-width="140px"
        :rules="formRules"
        class="form-wrap"
      >
        <!-- 模板名称 单独一行 -->
        <el-form-item label="模板名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入模板名称" style="width: 420px"></el-input>
        </el-form-item>

        <!-- 任务类型 单独一行 -->
        <el-form-item label="任务类型" prop="taskType">
          <!-- <el-select v-model="formData.taskType" placeholder="请选择任务类型" style="width: 420px">
            <el-option label="OUTFIT-穿搭" value="OUTFIT"></el-option>
            <el-option label="MEETING-例会" value="MEETING"></el-option>
          </el-select> -->
          <el-select v-model="formData.taskType" placeholder=""  style="width: 420px">
            <el-option
              v-for="(item, index) in taskTypeList"
              :key="index"
              :label="item.name"
              :value="item.no"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 执行日期区间 单独一行 -->
        <el-form-item label="执行日期区间" prop="dateRange">
          <el-date-picker
            v-model="formData.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 420px"
          ></el-date-picker>
        </el-form-item>

        <!-- 执行角色 单独一行 -->
        <el-form-item label="需要执行的角色" prop="requiredRoles">
          <el-select v-model="formData.requiredRoles" multiple placeholder="" style="width: 420px">
            <el-option
              v-for="(item, index) in roleList"
              :key="index"
              :label="item.roleName"
              :value="item.roleCode"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 最大上传图片数 单独一行 -->
        <el-form-item label="最大上传图片数" prop="maxImageCount">
          <el-input-number
            v-model="formData.maxImageCount"
            :min="0"
            placeholder="不填则无限制"
            style="width: 220px"
          ></el-input-number>
        </el-form-item>

        <!-- 最大上传视频数 单独一行 -->
        <el-form-item label="最大上传视频数" prop="maxVideoCount">
          <el-input-number
            v-model="formData.maxVideoCount"
            :min="0"
            placeholder="不填则无限制"
            style="width: 220px"
          ></el-input-number>
        </el-form-item>

        <!-- 备注 单独一行，文本域宽度一致 -->
        <el-form-item label="备注说明" prop="remark">
          <el-input
            v-model="formData.remark"
            type="textarea"
            :rows="5"
            placeholder="选填，填写模板备注说明"
            style="width: 420px"
          ></el-input>
        </el-form-item>

        <!-- 操作按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitForm">提交保存</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CreateTaskTemplate',
  data() {
    return {
      id: this.$route.query.id || null,
      formData: {
        name: '',
        taskType: '',
        dateRange: [],
        requiredRoles: '',
        maxImageCount: null,
        maxVideoCount: null,
        remark: ''
      },
      taskTypeList: [
        {
          name: '穿搭',
          no: 'OUTFIT'
        },
        {
          name: '例会',
          no: 'MEETING'
        },
      ],
      roleList:[],
      formRules: {
        name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ],
        taskType: [
          { required: true, message: '请选择任务类型', trigger: 'change' }
        ],
        dateRange: [
          { required: true, message: '请选择执行起止日期', trigger: 'change' }
        ],
        requiredRoles: [
          { required: true, message: '请填写执行角色，多角色英文逗号分隔', trigger: 'blur' }
        ]
      }
    }
  },
  // created() {
  //   // 页面进入立刻加载默认配置
  //   this.loadDefaultSetting()
  // },
  mounted() {
    this.getAllRoles()
    // 如果有查询id,则根据id去获取数据
    if (this.id) {
      this.titleShow = "编辑";
      this.getTemplateDefaultSetting()
    }
  },
  methods: {
    async loadDefaultSetting() {
      try {
        // 请求后端默认配置接口
        const res = await getTemplateDefaultSetting()
        const data = res.data
        // 回填表单默认值
        this.formData.maxImageCount = data.maxImageCount
        this.formData.maxVideoCount = data.maxVideoCount
        this.formData.requiredRoles = data.defaultRoles || ''
        // 如果后端返回默认任务类型可放开
        // this.formData.taskType = data.defaultTaskType
      } catch (err) {
        console.error('加载默认配置失败', err)
      }
    },
    async getTemplateDefaultSetting() {
        let res = await window.instance.post(window.retailinkUrl + '/taskTemplate/detail/'+this.id)
        res = res.data
        if (res.code === 200) {
            this.formData = res.data || {}
            this.formData.dateRange = [res.data.startDate, res.data.endDate]
            if (res.data.requiredRoles) {
              this.formData.requiredRoles = res.data.requiredRoles.split(',')
            } else {
              this.formData.requiredRoles = []
            }
            // 后端返回 taskType:"穿搭"，转换成编码 OUTFIT
            const targetName = res.data.taskType.trim()
            const targetItem = this.taskTypeList.find(item => item.name === targetName)
            if (targetItem) {
              this.formData.taskType = targetItem.no
            } else {
              this.formData.taskType = ''
            }
        } else {
            this.$message.error(res.message || '获取详情失败')
        }
    },
    async getAllRoles(){  //获取角色
      let res = await axios.post(retailinkUrl+"/taskTemplate/roles", {});
      res = res.data
      if (res.code === 200) {
        this.roleList = res.data;
      }
    },
     async submitForm() {
      let valid = false
      // 校验表单
      await new Promise(resolve => {
        this.$refs.form.validate(res => {
          valid = res
          resolve()
        })
      })
      if (!valid) return

      const params = {
        id: this.id,
        name: this.formData.name,
        taskType: this.formData.taskType,
        startDate: this.formData.dateRange[0],
        endDate: this.formData.dateRange[1],
        requiredRoles: this.formData.requiredRoles.join(','),
        maxImageCount: this.formData.maxImageCount,
        maxVideoCount: this.formData.maxVideoCount,
        remark: this.formData.remark
      }
      try {
        // await等待接口请求完成
        let url
        url = this.id ? '/taskTemplate/update' : '/taskTemplate/create'
        let res = await window.instance.post(window.retailinkUrl + url, params)
        res = res.data
        if (res.code === 200) {
            this.$message.success(res.message)
            this.$router.back()
            //window.close()
        } else {
            this.$message.error(res.message)
        }
      } catch (err) {
        this.$message.error(err.msg || '创建失败，请稍后重试')
      }
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.formData.dateRange = []
    }
  }
}
</script>

<style scoped lang="scss">
// 页面外层左右完全铺满，无两侧空白
.full-width-wrap {
  width: 100%;
  padding: 12px 20px;
  box-sizing: border-box;
}

// 卡片撑满父容器，缩小内部冗余留白
.full-card {
  width: 100%;
  /deep/ .el-card__body {
    padding: 28px;
    margin: 0;
  }
}

// 表单每行单独字段，垂直排布
.form-wrap {
  width: 100%;
}
/deep/ .form-wrap .el-form-item {
  margin-bottom: 20px;
}
// 强制标签文字单行不换行，兜底样式
/deep/ .el-form-item__label {
  white-space: nowrap;
  overflow: visible;
}
</style>


// WEBPACK FOOTER //
// src/pages/template/taskTemplateEdit.vue